import * as Sentry from "@sentry/browser";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import api from "../../../../api";
import urls from "../../../../urls";
import { queryWithPollResponse } from "../../../../utils/api-utils";
import type {
  MeterBasedDataSufficiencyResponse,
  NoDataSufficiencyResponse,
  WindDataSufficiencyResponse
} from "../EnergyDataElectricityTax/AvailabilityWidget/AvailabilityWidget";

export function useFetchDataSufficiencyAssessment(
  siteId: number,
  year: number
) {
  return useQuery({
    queryKey: ["data-sufficiency-assessment", { year, siteId }],
    queryFn: () => fetchDataSufficiencyAssessment(siteId, year),
    refetchInterval: false,
    refetchOnWindowFocus: false
  });
}

async function fetchDataSufficiencyAssessment(siteId: number, year: number) {
  const response = await queryWithPollResponse<
    | WindDataSufficiencyResponse
    | MeterBasedDataSufficiencyResponse
    | NoDataSufficiencyResponse
  >(
    (taskId?: string) =>
      api.get(urls.api.energyDataSufficiencyAssessment(siteId, year, taskId)),
    {
      queryAgainOnPollSuccess: true,
      queryAgainOnPollSuccessWithTaskId: true
    }
  );

  if (!response.data) {
    Sentry.captureMessage(
      `useFetchDataSufficiencyAssessment: response missing data for siteId ${siteId}, year ${year}`
    );
    throw new Error(t("errors.ServerError"));
  }

  return response.data;
}
